module.exports = __webpack_public_path__ + "static/ring_of_feather_falling-9cee2094dcfc125f9da805563b217edb.jpeg";